// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"41d5aa28","532":"70d34a36"}[chunkId] + ".chunk.css";
};